class CreamButton extends HTMLElement {
  constructor() {
    super()
    this.father = this.querySelector('[ff]')
    this.button = this.querySelector('[bb]')
  }

  connectedCallback() {
    let isCreated = this.getAttribute("created")
    if (isCreated == undefined) {
      this.update()
      this.setAttribute("created", true)
    }
  }

  update = () => {
    let call = this.button.getAttribute('call')
    let elm = document.querySelectorAll(call)
    this.button.addEventListener('click', () => {
      let mode = this.button.getAttribute('mode')
      this.button.parentNode.parentNode.parentNode.setAttribute("mode", mode)
      elm.forEach((ee) => {
        ee.parentNode.setAttribute("mode", mode)
        let isCreatedAux = ee.getAttribute("isActive")
        if (isCreatedAux == undefined) {
          ee.setAttribute("isActive", true)
        }
        else {
          ee.removeAttribute("isActive", true)
        }
      })
    })
  }
}

customElements.define('cream-button', CreamButton)